import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExternalConfigs } from "../../../api/models/external-configs";
import { getExternalConfigs } from "../../../api/config/ExternalConfig";

interface ExternalConfigsState {
  externalConfigs: ExternalConfigs | null;
}

const initialState: ExternalConfigsState = {
  externalConfigs: null,
};

export const fetchExternalConfigs = createAsyncThunk("fetchExternalConfigs", async () => {
  return await getExternalConfigs();
});

const externalConfigs = createSlice({
  name: "externalConfigs",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchExternalConfigs.fulfilled, (state, action: PayloadAction<ExternalConfigs>) => {
      state.externalConfigs = action.payload;
    });
  },
});

export default externalConfigs.reducer;
